import React, { useState, useEffect } from "react";
import TablaBalanzas from "../../../../components/lists/scaleList/index";
import MenuAdmin from "../../../../components/layout/menu";
import ResetFiltersButton from "../../../../components/filters/resetFiltersButton/index";
import FilterButton from "../../../../components/filters/filterButton/index";
import FilterInput from "../../../../components/filters/filterInput/index";
import SearchInput from "../../../../components/filters/searchInput/index";
import ExportButton from "../../../../components/shared/exportButton";
import { getScales } from "../../../../client/administration/scale/index";
import * as XLSX from 'xlsx';
import {  RiAddFill } from "react-icons/ri";
import ContentLoader from 'react-content-loader';
import Programate from "../../../../components/layout/footer";

const Balanzas = () => {
  const [currentRecordsCount, setCurrentRecordsCount] = useState(10);
  const [currentPage, setCurrentPage] = useState(1); 

  const [codes, setCodes] = useState([]);  
  const [plant, setPlant] = useState("");
  const [selectedCode, setSelectedCode] = useState("");
  const [selectedPlant, setSelectedPlant] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const [filteredRecords, setFilteredRecords] = useState([]);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true); // Estado de carga

  const [showModalAddScale, setShowModalAddScale] = useState(false);

  const openModalAddScale = () => {
    setShowModalAddScale(true);
  };

  const closeModalAddScale = () => {
    setShowModalAddScale(false);
  };

  const [isMenuOpen, setIsMenuOpen] = useState(false); 
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    useEffect(() => {
      const fetchScales = async () => {
        try {
          const response = await getScales();
        //  console.log("Registros obtenidos:", response.data); // Verifica los registros obtenidos

          setRecords(response.data);
          setFilteredRecords(response.data);
          const uniqueCodes = [...new Set(response.data.map(record => record.scaleCode))];
          setCodes(uniqueCodes);
        } catch (error) {
          console.error('Error fetching scales:', error);
        } finally {
          setLoading(false); // Detener el loading después de obtener los datos
        }
      };
  
      fetchScales();
    }, []);
 
    const handleSearch = (value) => {
      setSearchTerm(value);
      const filtered = records.filter(record => {
        const lowerCaseValue = value.toLowerCase();
        const matches = (
          record.scaleCode.toLowerCase().includes(lowerCaseValue) ||
          record.serialCode.toLowerCase().includes(lowerCaseValue) ||
          (record.stand && record.stand.standName && record.stand.standName.toLowerCase().includes(lowerCaseValue)) ||
          (record.stand && record.stand.site && record.stand.site.siteName && record.stand.site.siteName.toLowerCase().includes(lowerCaseValue)) ||
          (record.stand && record.stand.direction && record.stand.direction.toLowerCase().includes(lowerCaseValue)) ||
          (record.scaleModel && record.scaleModel.modelName && record.scaleModel.modelName.toLowerCase().includes(lowerCaseValue)) ||
          (record.scaleModel && record.scaleModel.scaleBrand && record.scaleModel.scaleBrand.brandName && record.scaleModel.scaleBrand.brandName.toLowerCase().includes(lowerCaseValue)) ||
          (record.scaleModel && record.scaleModel.maximunCapacity && record.scaleModel.maximunCapacity.toString().includes(value)) ||
          (record.scaleModel && record.scaleModel.minimunCapacity && record.scaleModel.minimunCapacity.toString().includes(value))
        );
        if (matches) {
        //  console.log("Registro coincidente:", record); 
        }
        return matches;
      });
      setFilteredRecords(filtered);
    };


  // Función para manejar el filtro por codigo dropdown
  const handleFilterByCod = (code) => {
    setSelectedCode(code);
    const filtered = records.filter(record =>
    record.scaleCode && record.scaleCode.includes(code));
    setFilteredRecords(filtered);
  };

//filtro por planta input
  const handleFilterByPlant = (plant) => {
   // console.log("Valor de planta ingresado:", plant);
    setPlant(plant);
    const filtered = records.filter(record => 
      record.stand && 
      record.stand.site && 
      record.stand.site.siteName.toLowerCase().includes(plant.toLowerCase())
    );
  //  console.log("Registros filtrados:", filtered);
    setFilteredRecords(filtered);
  };

  // Función para restablecer los filtros
  const handleResetFilters = () => {
    setSearchTerm("");
    setPlant("");
    setSelectedCode("");
   // setFilteredRecords(records);
   // setFilteredRecords("");
  };


  
  const handleExportToExcel = () => {
    const exportData = records.map(record => ({
      id: String(record.id),
      Planta: record.stand.site.siteName,
      Ubicación: record.stand.site.direction,
      Código: record.scaleCode,
      Marca: record.scaleModel.scaleBrand.brandName,
      Modelo: record.scaleModel.modelName,
      Serie: record.serialCode,
      CapacidadMin: String(record.scaleModel.minimunCapacity),
      CapacidadMax: String(record.scaleModel.maximunCapacity),
      FechaRegistro: new Date(record.createdAt).toLocaleString()
    }));
  
    const ws = XLSX.utils.json_to_sheet(exportData);
  
    // títulos de las columnas
    ws['A1'].v = 'ID';
    ws['B1'].v = 'Planta';
    ws['C1'].v = 'Ubicación';
    ws['D1'].v = 'Código';
    ws['E1'].v = 'Marca';
    ws['F1'].v = 'Modelo';
    ws['G1'].v = 'Serie';
    ws['H1'].v = 'Capacidad Min';
    ws['I1'].v = 'Capacidad Max';
    ws['J1'].v = 'Fecha Registro';
  
    for (let i = 2; i <= exportData.length + 1; i++) {
      ws[`A${i}`].s = { alignment: { horizontal: "left" } };
      ws[`B${i}`].s = { alignment: { horizontal: "left" } };
      ws[`C${i}`].s = { alignment: { horizontal: "left" } };
      ws[`D${i}`].s = { alignment: { horizontal: "left" } };
      ws[`E${i}`].s = { alignment: { horizontal: "left" } };
      ws[`F${i}`].s = { alignment: { horizontal: "left" } };
      ws[`G${i}`].s = { alignment: { horizontal: "left" } };
      ws[`H${i}`].s = { alignment: { horizontal: "left" } };
      ws[`I${i}`].s = { alignment: { horizontal: "left" } };
      ws[`J${i}`].s = { alignment: { horizontal: "left" } };

    }

    //  ancho de las columnas
    ws['!cols'] = [
      { wch: 10 }, //  (ID)
      { wch: 20 }, //  (Planta)
      { wch: 25 }, //  (Ubicación)
      { wch: 15 }, //  (Código)
      { wch: 15 }, //  (Marca)
      { wch: 15 }, //  (Modelo)
      { wch: 15 }, //  (Serie)
      { wch: 20 }, //  (Capacidad Min)
      { wch: 20 }, //  (Capacidad Max)
      { wch: 25 }  //  (Fecha Registro)
    ];
  
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Balanzas");
  
    XLSX.writeFile(wb, "balanzas.xlsx");
  };

  
  const handleRecordsCountChange = (event) => {
    const newCount = parseInt(event.target.value, 10);
    setCurrentRecordsCount(newCount); // Actualiza el número de registros por página
    setCurrentPage(1); // Reinicia a la primera página
  };

  const isExportDisabled = filteredRecords.length === 0; 


  return (
    <div className="flex w-full min-h-screen ">
      <MenuAdmin isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
      <div className={`flex-1 transition-all duration-300 ml-0 ${isMenuOpen ? "lg:ml-[220px] sm:ml-[0] md:ml-[0]" : "ml-0"} w-[83%]`}>
        <div className="flex flex-col min-h-screen justify-between">
          <div className="pb-12  px-[3%] ">
            {loading ? (
              <div className="pb-8 pt-32 sm:-space-y-20 -space-y-2">
                <ContentLoader
                  viewBox="0 0 1200 200"
                  height="100%"
                  width="100%"
                  backgroundColor="#f3f3f3"
                  foregroundColor="#ecebeb"
                  speed={5}
                >
                  <rect x="0" y="0" width="17%" height="40" rx="5" ry="5" /> {/* Título "Balanzas" */}
                  <rect x="0" y="60" width="20%" height="40" rx="5" ry="5" /> {/* Filtro por planta */}
                  <rect x="22%" y="60" width="20%" height="40" rx="5" ry="5" /> {/* Filtro por código */}
                  <rect x="72%" y="60" width="28%" height="40" rx="5" ry="5" /> {/* Barra de búsqueda */}
                  <rect x="0" y="120" width="16%" height="40" rx="5" ry="5" /> {/* Botón "Agregar balanza" */}
                  <rect x="76%" y="120" width="13%" height="40" rx="5" ry="5" /> {/* Botón "Reset" */}
                  <rect x="90%" y="120" width="10%" height="40" rx="5" ry="5" /> {/* Botón "Exportar" */}
                </ContentLoader>
    
                {/* Skeleton para la tabla */}
                <ContentLoader
                  width="100%"
                  height="100%"
                  viewBox="0 0 1500 400"
                  backgroundColor="#f3f3f3"
                  foregroundColor="#ecebeb"
                  speed={5}
                >
                   {/* Columnas de la tabla */}
                  <rect x="0%" y="139" rx="4" ry="4" width="5%" height="20" />
                  <rect x="7%" y="140" rx="10" ry="10" width="35%" height="19" />
                  <rect x="44%" y="141" rx="10" ry="10" width="25%" height="19" />
                  <rect x="72%" y="142" rx="10" ry="10" width="12%" height="19" />
                  <rect x="86%" y="143" rx="10" ry="10" width="12%" height="19" />
    
                  <rect x="0%" y="196" rx="4" ry="4" width="5%" height="20" />
                  <rect x="7%" y="197" rx="10" ry="10" width="35%" height="19" />
                  <rect x="44%" y="198" rx="10" ry="10" width="25%" height="19" />
                  <rect x="72%" y="197" rx="10" ry="10" width="12%" height="19" />
                  <rect x="86%" y="198" rx="10" ry="10" width="12%" height="19" />
              
                  <rect x="0%" y="258" rx="4" ry="4" width="5%" height="20" />
                  <rect x="7%" y="259" rx="10" ry="10" width="35%" height="19" />
                  <rect x="44%" y="260" rx="10" ry="10" width="25%" height="19" />
                  <rect x="72%" y="259" rx="10" ry="10" width="12%" height="19" />
                  <rect x="86%" y="260" rx="10" ry="10" width="12%" height="19" />
              
                  <rect x="0%" y="316" rx="4" ry="4" width="5%" height="20" />
                  <rect x="7%" y="317" rx="10" ry="10" width="35%" height="19" />
                  <rect x="44%" y="318" rx="10" ry="10" width="25%" height="19" />
                  <rect x="72%" y="317" rx="10" ry="10" width="12%" height="19" />
                  <rect x="86%" y="318" rx="10" ry="10" width="12%" height="19" />
                </ContentLoader>
              </div>
            ) : (
              <div className="w-full pb-10 pt-28">
                <h1 className="text-[32px]  font-itcbold text-[#007696] text-center lg:text-left ">Balanzas</h1>
                <div className="flex flex-col items-start justify-center md:gap-3">
                  {/* Filtros */}
                  <div className="flex flex-col items-start justify-between w-full gap-5 mb-4 md:items-center md:mb-0 md:flex-row ">
                    <div className="flex flex-col items-start gap-3 my-1 md:gap-0 md:items-center md:space-x-5 md:flex-row md:my-4 ">
                      <FilterInput
                        placeholder="Filtrar por planta"
                        value={plant}
                        onChange={(e) =>  handleFilterByPlant(e.target.value)}
                        selectedPlant = {selectedPlant}
                      />
                      <FilterButton
                        text="Filtrar por código"
                        options={codes}
                        onSelect={handleFilterByCod} 
                        selectedOption={selectedCode}
                      />
                      
                    </div>
                    <div className="hidden md:block">
                    <SearchInput 
                      placeholder='Buscar' 
                      value={searchTerm}
                      onChange={handleSearch}
                    /> 
                    </div>
    
                  </div>
    
                  <div className="flex flex-col-reverse items-end justify-between w-full gap-4 md:items-center md:flex-row ">
                    {/** 
                    <div className="flex items-center justify-center space-x-2">
                      <p className="text-sm text-[#76A140] font-itcbook">Mostrar</p>
                      <div className="border-[#76A140] border-[1px] rounded-md w-[58px] flex justify-center items-center h-[40px]">
                        <select
                          className="text-sm text-[#76A140] font-itcbook px-2 w-full h-full bg-white rounded-md outline-none"
                          value={currentRecordsCount}
                          onChange={handleRecordsCountChange}  
                        >
                          <option value={10}>10</option>
                          <option value={15}>15</option>
                          <option value={25}>25</option>
                          <option value={50}>50</option>
                        </select>
                      </div>
                      <p className="text-sm text-[#76A140] font-itcbook">Registros</p>
                    </div>
                    */} 
                    <div className="flex items-center justify-center w-full md:justify-start">
                      <button
                        onClick={openModalAddScale}
                        className="flex items-center justify-center h-[40px] p-3 px-5 space-x-4 text-white rounded-md bg-green"
                      >
                        <RiAddFill className="flex text-[14px] font-itcmedium" /> 
                          Agregar balanza
                      </button>
                    </div>
                    <div className="flex items-center justify-between w-full gap-2 md:justify-end ">
                      <ResetFiltersButton 
                      onClick={handleResetFilters}
                      /> 
                      <ExportButton onClick={handleExportToExcel}  disabled={isExportDisabled}/>  
                    </div>
                  </div> 
                  <div className="flex items-center justify-center block w-full pt-3 md:hidden">
                     <SearchInput 
                      placeholder='Buscar' 
                      value={searchTerm}
                      onChange={handleSearch}
                    /> 
                  </div>
                  <TablaBalanzas 
                    data={records} 
                    filterCode={selectedCode}
                    filterPlant={plant} 
                    onFilterCodeChange={setSelectedCode} 
                    onFilterPlantChange={setPlant}
                    recordsPerPage={currentRecordsCount}  
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    searchTerm={searchTerm}
                    onSearchTermChange={handleSearch}
                    showModalAddScale={showModalAddScale}
                    closeModalAddScale={closeModalAddScale}
                  />
                  
                </div>
              </div>
            )}
          </div>
          <Programate/>
        </div>
      </div>            
    </div> 
  );
};

export default Balanzas;